export class AuthorizedSenderEmailAddressDTO{
    public id!: number;
    public customerId!: number;
    public emailAddress!: string;
    public description!: string;
    public enabled!: boolean;
    public unzipZipFiles!: boolean;
    public unzipPassword!: string;
    public added!: string;
    public edited!: string;
}